import { HAS_WINDOW } from './window.js';

/** Whether CSS Houdini features are supported, like `CSS.registerProperty`. */
const HAS_HOUDINI = HAS_WINDOW && CSS.registerProperty;
/**
 * This is an identity function that is used mostly as documentation and also to avoid having
 * to always cast css variables to `any` when passing them into react's `style` prop.
 *
 * @example
 *
 * <div style={{ [cssVar('--foo')]: 42 }} />
 */
function cssVar(name) {
    return name;
}
/**
 * Extract the inner part of a css var string. Useful for assigning to vanilla extract variables
 * created with `createVar()`, since those always include the full `var(--foo)` syntax.
 * Cheaper than pulling in the full `@vanilla-extract/dynamic` package and using `assignInlineVars`.
 *
 * @example
 * getVarName('var(--foo)') // '--foo'
 * getVarName('--foo') // '--foo'
 */
function getVarName(variable) {
    const matches = variable.match(/^var\((.*)\)$/);
    return (matches ? matches[1] : variable);
}
/**
 * Convert a number to a css px string. Uses 1 decimal of precision.
 *
 * @note You don't need this if you're passing values to a react component's `style` prop because
 *   react will automatically convert numbers to px strings.
 */
function px(value) {
    return value ? `${value.toFixed(1)}px` : '0';
}
function rems(value) {
    return value ? `${value / 16}rem` : undefined;
}
/** Convert a value between 0 and 1 to a css % string. */
function percentToCss(value) {
    return `${(value * 100).toFixed(2)}%`;
}

export { HAS_HOUDINI, cssVar, getVarName, percentToCss, px, rems };
//# sourceMappingURL=css.js.map
